import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      firstName: '',
      lastName: '',
      telephone: '',
      mobile: '',
      newsletterSubscribed: null,
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    profileBtnDisabled () {
      return !(this.currentPassword && this.newPasswordState && this.confirmPasswordState)
    },
    telephoneState () {
      return !this.telephone || /^0\d{10,14}$/.test(this.telephone)
    },
    mobileState () {
      return /^0\d{10,14}$/.test(this.mobile)
    },
    newPasswordState () {
      if (this.newPassword) {
        return this.newPassword.length > 5 && this.newPassword.length < 20
      }
      return null
    },
    confirmPasswordState () {
      if (this.confirmPassword) {
        return this.confirmPassword === this.newPassword
      }
      return null
    },
    updateProfileDisabled () {
      return !(this.firstName && this.lastName && this.telephoneState && this.mobileState)
    },
    updatePasswordDisabled () {
      return !(this.currentPassword && this.newPasswordState && this.confirmPasswordState)
    },
  },
  methods: {
    ...mapActions(['updateCustomer', 'createCustomer', 'getCustomer']),
    updateDetail () {
      if (this.currentUser) {
        this.firstName = this.currentUser.first_name
        this.lastName = this.currentUser.last_name
        this.telephone = this.currentUser.phone_number
        this.mobile = this.currentUser.phone_number_mobile
        this.newsletterSubscribed = this.currentUser.newsletter_subscribed === 1
      }
    },
    NumbersOnly (evt) {
      const charCode = evt.which ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    updateProfile (passwordUpdate = false) {
      let data = {}
      if (passwordUpdate) {
        data = {
          id: this.currentUser ? this.currentUser.id : null,
          current_password: this.currentPassword,
          new_password: this.newPassword
        }
      } else {
        data = {
          id: this.currentUser ? this.currentUser.id : null,
          first_name: this.firstName,
          newsletter_subscribed: this.newsletterSubscribed
        }
        if (['web', 'app'].includes(this.$platform)) {
          data.last_name = this.lastName
          data.phone_number = this.telephone
          data.phone_number_mobile = this.mobile
        }
        if (this.$platform === 'pos') {
          if (this.searchedBy) {
            data[this.searchedBy] = this.searchedBy === 'phone_number' ? this.phone_number : this.phone_number_mobile
          } else {
            data.phone_number_mobile = this.mobile
          }
        }
      }
      this.showLoading()
      this.updateCustomer(data).then((data) => {
        this.showAlert(data.message, data.status === 'Success' ? 'success' : 'danger', data.status)
        if (data.status === 'Success') {
          this.currentPassword = this.newPassword = this.confirmPassword = ''
          if (this.$platform === 'web') {
            this.redirectToHome()
          }
        }
      }).finally(() => {
        this.hideLoading()
      })
    },
    createProfile () {
      this.showLoading()
      const data = {
        first_name: this.firstName,
        phone_number_mobile: this.mobile
      }
      this.createCustomer(data).then((data) => {
        this.showAlert(data.message, data.status === 'Success' ? 'success' : 'danger', data.status)
      }).finally(() => {
        this.hideLoading()
      })
    }
  },
  mounted () {
    if (this.currentUser) {
      this.updateDetail()
      this.getCustomer().then(() => {
        this.updateDetail()
      })
    }
    if (!this.currentUser && this.phone) {
      this.mobile = this.phone
    }
  }
}
